// eslint-disable-next-line import/no-extraneous-dependencies
import isPlainObject from 'lodash.isplainobject';

import { toSnakeCase } from 'wanderu-utils';

// eslint-disable-next-line sort-imports
import { StructuredEventError } from './errors/StructuredEventErrors';

class StructuredEvent {
    constructor({
        category, action, label, property, value, context,
    }) {
        this.category = category;
        this.action = action;
        this.label = label;
        this.property = property;
        this.value = value;
        this.context = context;

        this.assertValidEvent();
    }

    normalizeNonStringObjects(property) {
        if (!property || typeof property === 'string') {
            return property;
        }

        if (isPlainObject(property)) {
            return JSON.stringify(this.snakeCaseObjectKeys(property));
        }

        return JSON.stringify(property);
    }

    // eslint-disable-next-line
    snakeCaseObjectKeys(object) {
        return Object.entries(object)
            .reduce((obj, [key, value]) => ({ ...obj, [toSnakeCase(key)]: value }), {});
    }

    format() {
        return [
            'trackStructEvent',
            {
                category: toSnakeCase(this.category),
                context: this.context,
                action: toSnakeCase(this.action),
                label: toSnakeCase(this.label),
                property: this.normalizeNonStringObjects(this.property),
                value: this.value,
            },
        ];
    }

    // Following goo.gl/gTTcEb
    assertValidEvent() {
        if (!this.category) {
            throw new StructuredEventError('Category must be supplied');
        }

        if (typeof this.category !== 'string') {
            throw new StructuredEventError(
                'Category must be a string. Value supplied:',
                this.category,
            );
        }

        if (!this.action) {
            throw new StructuredEventError('Action must be supplied');
        }

        if (typeof this.action !== 'string') {
            throw new StructuredEventError(
                'Action must be a string. Value supplied:',
                this.action,
            );
        }

        if (this.label && typeof this.label !== 'string') {
            throw new StructuredEventError('Label must be a string. Value supplied:', this.label);
        }

        if (this.value && typeof this.value !== 'number') {
            throw new StructuredEventError('Value must be a number. Value supplied:', this.value);
        }
    }
}

export default StructuredEvent;
